import { render, staticRenderFns } from "./MergedAnnotationTablesDisplayer.vue?vue&type=template&id=08f69ec8&scoped=true&"
import script from "./MergedAnnotationTablesDisplayer.vue?vue&type=script&lang=js&"
export * from "./MergedAnnotationTablesDisplayer.vue?vue&type=script&lang=js&"
import style0 from "./MergedAnnotationTablesDisplayer.vue?vue&type=style&index=0&id=08f69ec8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f69ec8",
  null
  
)

export default component.exports